import { useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { requestCheckObject } from '../redux/actions/aws/actions';
import { AwsParamVO } from '../commons/vo/param/AwsParamVO';

export default function useAws() {
  const dispatch = useDispatch();
  
  const onRequestCheckObject = useCallback(
    (param: AwsParamVO) => {
    dispatch(requestCheckObject({ param }))
  }, [dispatch]);

  return useMemo(
    () => ({
      onRequestCheckObject,
    }),
    [
      onRequestCheckObject,
    ]
  );
}
